import { Component } from '@angular/core';
import { CustomersDetailsComponent } from './customers-details.component';

@Component({
  selector: 'app-customers-details-wrapper',
  imports: [
    CustomersDetailsComponent
  ],
  template: `
    <div class="page-container">
      <app-customers-details></app-customers-details>
    </div>
  `,
  styles: [`
    .page-container {
      padding: 20px;
      max-width: 1400px;
      margin: 0 auto;
    }

    @media (max-width: 768px) {
      .page-container {
        padding: 16px;
      }
    }
  `]
})
export class CustomersDetailsWrapperComponent {}